import {_, $, iFrameResize, getScrollbarWidth} from './util';
import _PHP from './_PHP';
import {router, layout} from './routerAndLayout';
import CarSearch from './listing/CarSearch';
import sectionContact from './section/contact';

if (window.history) { window.history.scrollRestoration = "manual"; }



class App {
  constructor() {
    layout.init();
    setTimeout(() => {
      $("html").addClass("ready");
    }, 1);

    this.html_strs = {
      contactNote: $("#contact_note").html()
    };

    this.vehicles = _PHP.vehicles;
    this.addHiddenScrollbarHolder();
  }

  addHiddenScrollbarHolder() {
    const style = document.createElement('style');
    style.textContent = (
      `
        html.page-sale .item-in-focus .main-container,
        html.page-search.item-in-focus .main-container {
          padding-right: ${getScrollbarWidth()}px;
        }
        .off_vehicle.expanded-animation-end .details {
          padding-right: ${getScrollbarWidth()}px;
        }
      `
    );
    document.head.appendChild(style);
  }

  init() {
    const carSearchNew = new CarSearch({
      formid: _PHP.mixedmode ? 'stock' : 'new',
      urlpath: _PHP.mixedmode ? '/stock/' : '/new/',
      order: 'unique',
      distinctDealer: _PHP.dealer || "",
      formSelector: "#result-new-cover .filter-wrp",
      contactNote: this.html_strs.contactNote,
      resultSelector: "#result-list-new",
      items: _.filter(this.vehicles, (r) => {
        if (_PHP.salemode && r.ctx_whitelist.indexOf("sale_") > -1) {
          return false;
        }
        return _PHP.mixedmode ? true : r.newcar;
      })
    });

    let carSearchUsed = null;

    if (_PHP.usedCarsEnabled && !_PHP.mixedmode) {
      carSearchUsed = new CarSearch({
        formid: "used",
        urlpath: 'used/',
        order: 'unique',
        distinctDealer: _PHP.dealer || "",
        formSelector: "#result-used-cover .filter-wrp",
        contactNote: this.html_strs.contactNote,
        resultSelector: "#result-list-used",
        items: _.filter(this.vehicles, (r) => {
          if (_PHP.salemode && r.ctx_whitelist.indexOf("sale_") > -1) {
            return false;
          }
          return !r.newcar;
        })
      });
    }

    let carSearchSale = null;

    if (_PHP.salemode) {
      carSearchSale = new CarSearch({
        formid: "sale",
        urlpath: 'sale/',
        order: 'unique',
        distinctDealer: _PHP.dealer || "",
        formSelector: "#result-sale-cover .filter-wrp",
        contactNote: this.html_strs.contactNote,
        resultSelector: "#result-list-sale",
        items: _.filter(this.vehicles, (r) => {
          if (_PHP.salemode && r.ctx_whitelist.indexOf("sale_") > -1) {
            return true;
          }
          if (_PHP.salemodeInclude) {
            for (let i = 0; i < _PHP.salemodeInclude.length; i++) {
              const filterCond = _PHP.salemodeInclude[i];
              if (r[filterCond.property] === filterCond.value) {
                r.saleClass = filterCond.extraClass;
                r.saleDefaultLeadCtxId = filterCond.defaultLeadCtxId;
                return true;
              }
            }
          }
          return false;
        })
      });
    }

    function updateViewport() {
      if (carSearchNew instanceof CarSearch) {
        carSearchNew.viewPortUpdationsDelayed();
      }

      if (carSearchUsed instanceof CarSearch) {
        carSearchUsed.viewPortUpdationsDelayed();
      }

      if (carSearchSale instanceof CarSearch) {
        carSearchSale.viewPortUpdationsDelayed();
      }
    }

    $(window).on("resize scroll", updateViewport);
    updateViewport();

    router.init({
      getResultItem: (carid, formid) => {
        if (formid === "new" || formid === "stock") {
          return carSearchNew.getResultItemByData("_id", carid, true);
        }
        if (formid === "used") {
          return carSearchUsed.getResultItemByData("_id", carid, true);
        }
        if (formid === "sale") {
          return carSearchSale.getResultItemByData("_id", carid, true);
        }
        return (
          carSearchNew && carSearchNew.getResultItemByData("_id", carid, true)
        ) || (
          carSearchUsed && carSearchUsed.getResultItemByData("_id", carid, true)
        ) || (
          carSearchSale && carSearchSale.getResultItemByData("_id", carid, true)
        );
      }
    });

    sectionContact.view();


    $(document).ready(function() {
      iFrameResize({
        // heightCalculationMethod: 'max'
      }, '.resize-iframe');
    });

  }
};


export default App;
